// lib/pacific-day.js
// The Bay's calendar day and calendar-day arithmetic. ZERO imports, on
// purpose: components/Map.jsx reads the Pacific day from here, and importing
// it through lib/hub-data.js bundled hub-data's dedup + identity modules into
// dist/Map.js, re-running their window.ClientDedup / window.EventIdentity
// assignments on a page that already loads both. lib/hub-data.js re-exports
// both names, so its importers are unchanged. tests/seasonal-rail.test.js
// fails if an import appears here.

// ── The Bay's calendar, never the runtime's ──────────────────────────────
// Pages Functions execute at the edge on UTC; toISOString().slice(0,10) is
// the wrong day for ~5 hours of every Pacific evening — exactly the hours
// a page called "tonight" is most used.
export function pacificTodayIso(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now);
}

// A calendar day is anchored at noon UTC before any arithmetic so neither
// DST edge can slip it backward across a date boundary.
const anchor = (iso) => new Date(`${iso}T12:00:00Z`);

export function addDays(iso, n) {
  const d = anchor(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}
